export const PreLoad = (imageUrls: any, setImages: any, images: any) => {
  Object.keys(imageUrls).forEach((thumbnailProp) => {
    const img = new Image();
    img.src = imageUrls[thumbnailProp];
    img.onload = () => {
      setImages((images: any) => ({...images, [thumbnailProp]: imageUrls[thumbnailProp]}));
    }
    img.onerror = (images: any) => ({...images, [thumbnailProp]: "failed"})
  });
}